module.exports = __webpack_public_path__ + "img/THS-logo-transparant.66cd2041.png";